import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RsvpPage from './pages/RsvpPage';
import TicketPage from './pages/TicketPage';
import StaffLogin from './pages/StaffLogin';
import ScannerPage from './pages/ScannerPage';
import AdminPage from './pages/AdminPage';
import ComingSoon from './pages/ComingSoon';
import './App.css';

function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<RsvpPage />} />
      {/* <Route path="/festival" element={<ComingSoon />} /> */}
      {/* <Route path="/festival" element={<RsvpPage />} /> */}
      <Route path="/ticket/:id" element={<TicketPage />} />

      {/* Staff */}
      <Route path="/staff" element={<StaffLogin />} />
      <Route path="/staff/scanner" element={<ScannerPage />} />
      <Route path="/staff/admin" element={<AdminPage />} />
    </Routes>
  );
}

export default App;
